<template>
  <router-view/>
</template>

<script>
export default {
  name: "Blank"
}
</script>
